/**
 * INP (Interaction to Next Paint) Optimization
 * Improves responsiveness and user experience
 */

// Use requestIdleCallback for non-critical operations
const scheduleIdleTask = (callback) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 2000 });
  } else {
    // Fallback for browsers that don't support requestIdleCallback
    setTimeout(callback, 1);
  }
};

// Load analytics and other non-critical scripts during idle time
document.addEventListener('DOMContentLoaded', () => {
  scheduleIdleTask(() => {
    // Analytics loading can be deferred
    const analyticsScripts = [
      // Add your analytics script URLs here
    ];
    
    analyticsScripts.forEach(script => {
      const s = document.createElement('script');
      s.src = script;
      s.async = true;
      s.defer = true;
      document.body.appendChild(s);
    });
  });
});

// Debounce function to limit the frequency of expensive operations
const debounce = (func, wait = 100) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

// Optimize event handlers for better INP
document.addEventListener('DOMContentLoaded', () => {
  // Optimize scroll events
  const optimizedScroll = debounce(() => {
    // Your scroll handling code here
  }, 16); // Roughly 60fps
  
  window.addEventListener('scroll', optimizedScroll, { passive: true });
  
  // Optimize resize events
  const optimizedResize = debounce(() => {
    // Your resize handling code here
  }, 100);
  
  window.addEventListener('resize', optimizedResize, { passive: true });
  
  // Use touchstart/mousedown events for faster response
  document.querySelectorAll('.quick-add-button, .variant-selector, .add-to-cart-button').forEach(button => {
    button.addEventListener('touchstart', function(e) {
      // Optional: add active state visually
      this.classList.add('active');
    }, { passive: true });
    
    button.addEventListener('touchend', function() {
      this.classList.remove('active');
    }, { passive: true });
  });
});

// Use the Web Animation API for smoother animations
const animateElement = (element, keyframes, options) => {
  if ('animate' in element) {
    return element.animate(keyframes, options);
  }
  return null;
};

// Optimize images loading with priority for visible content
document.addEventListener('DOMContentLoaded', () => {
  const deferImages = () => {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
              }
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');
            }
            imageObserver.unobserve(img);
          }
        });
      });
      
      lazyImages.forEach(img => {
        imageObserver.observe(img);
      });
    }
  };
  
  // Defer image optimization
  scheduleIdleTask(deferImages);
});

// Optimize third-party scripts loading
const optimizeThirdPartyScripts = () => {
  const thirdPartyScripts = document.querySelectorAll('script[data-type="third-party"]');
  thirdPartyScripts.forEach(script => {
    // Make third-party scripts async
    script.async = true;
    
    // For scripts that don't need to load immediately
    if (script.dataset.priority !== 'high') {
      scheduleIdleTask(() => {
        // Load on idle 
      });
    }
  });
};

// Run this optimization when possible
scheduleIdleTask(optimizeThirdPartyScripts); 